import { useState } from "react";
import type { User } from "@shared/core/types";
import { api, ApiError } from "../lib/api";
import { useAuthStore } from "../stores/auth";
import { useToastStore } from "../stores/toast";
import { PageHeader } from "../components/ui/page-header";
import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";
import { Field, Input } from "../components/ui/input";

export function ProfilePage() {
  const user = useAuthStore((s) => s.user);
  const setUser = useAuthStore((s) => s.setUser);
  const push = useToastStore((s) => s.push);
  const [name, setName] = useState(user?.name ?? "");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const saveName = async () => {
    setBusy(true);
    try {
      const u = await api<User>("/api/me", { method: "PATCH", body: JSON.stringify({ name }) });
      setUser(u);
      push("success", "Nom mis à jour");
    } catch {
      push("danger", "Enregistrement impossible");
    } finally {
      setBusy(false);
    }
  };

  const savePassword = async () => {
    setBusy(true);
    try {
      await api<User>("/api/me", { method: "PATCH", body: JSON.stringify({ currentPassword, newPassword }) });
      setCurrentPassword("");
      setNewPassword("");
      push("success", "Mot de passe changé");
    } catch (e) {
      push("danger", e instanceof ApiError && e.code === "wrong_password" ? "Mot de passe actuel incorrect" : "Changement impossible");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page">
      <PageHeader title="Mon profil" subtitle={user?.email} />
      <div className="settings-grid">
        <Card
          title="Identité"
          footer={
            <Button variant="primary" onClick={saveName} disabled={busy || !name.trim()}>
              Enregistrer
            </Button>
          }
        >
          <Field label="Nom affiché">
            <Input value={name} onChange={(e) => setName(e.target.value)} />
          </Field>
        </Card>
        <Card
          title="Mot de passe"
          footer={
            <Button variant="primary" onClick={savePassword} disabled={busy || !currentPassword || newPassword.length < 8}>
              Changer le mot de passe
            </Button>
          }
        >
          <div className="form-grid">
            <Field label="Mot de passe actuel">
              <Input
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                autoComplete="current-password"
              />
            </Field>
            <Field label="Nouveau mot de passe" hint="Au moins 8 caractères.">
              <Input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                autoComplete="new-password"
                minLength={8}
              />
            </Field>
          </div>
        </Card>
      </div>
    </div>
  );
}
